{
	"noData": {
		"title": "Não encontramos o que você procura",
		"description": "Tente selecionar um novo local ou período, ou tente novamente mais tarde."
	},
	"noFilters": {
		"title": "Ainda não tem nada por aqui",
		"description": "Selecione o local da pesquisa ou verifique novamente mais tarde."
	},
	"noContent": {
		"title": "Ainda não tem nada por aqui",
		"description": "Selecione um período para começar a explorar os dados."
	}
}
